export default __webpack_public_path__ + "static/media/next-page-pagination.c9b4fe7a.svg";